import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from '../App';

// 懒加载工作流页面
const WorkflowListPage = lazy(() => import('../pages/workflow/WorkflowListPage'));
const WorkflowEditorPage = lazy(() => import('../pages/workflow/WorkflowEditorPage'));

// 加载状态组件
function PageLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-purple-200 rounded-full" />
          <div className="absolute inset-0 border-4 border-purple-500 rounded-full border-t-transparent animate-spin" />
        </div>
        <p className="text-gray-600 font-medium">加载中...</p>
      </div>
    </div>
  );
}

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

// 主布局组件 - 包含 QueryClientProvider
function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
    </QueryClientProvider>
  );
}

export function Router() {
  return (
    <BrowserRouter basename="/product-team-v3">
      <Routes>
        <Route element={<RootLayout />}>
          {/* 主应用 - 设计器 */}
          <Route path="/" element={<App />} />
          
          {/* 工作流管理路由 - 懒加载 */}
          <Route path="/workflow" element={
            <Suspense fallback={<PageLoading />}>
              <WorkflowListPage />
            </Suspense>
          } />
          <Route path="/workflow/:id" element={
            <Suspense fallback={<PageLoading />}>
              <WorkflowEditorPage />
            </Suspense>
          } />
          
          {/* 404 重定向到首页 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
